export default __webpack_public_path__ + "static/media/profile-pic.9db8da37.png";